import { Capacitor } from '@capacitor/core'
import {
  PushNotifications,
  type Token,
  type PushNotificationSchema,
  type ActionPerformed,
} from '@capacitor/push-notifications'

import { budgetApi } from '../services/budget-api'

const registeredTokenKey = 'budget-quotidien-push-token'

/**
 * Enregistre l'appareil pour les notifications push (Android/iOS uniquement, via Capacitor).
 * À appeler une fois l'utilisateur authentifié. Ne fait rien sur le web.
 */
export const initPushNotifications = async () => {
  if (!Capacitor.isNativePlatform()) {
    return
  }

  const permission = await PushNotifications.checkPermissions()

  if (permission.receive === 'prompt' || permission.receive === 'prompt-with-rationale') {
    const requested = await PushNotifications.requestPermissions()
    if (requested.receive !== 'granted') {
      return
    }
  } else if (permission.receive !== 'granted') {
    return
  }

  await PushNotifications.register()

  PushNotifications.addListener('registration', async (token: Token) => {
    try {
      await budgetApi.registerPushToken(token.value, Capacitor.getPlatform() as 'android' | 'ios')
      localStorage.setItem(registeredTokenKey, token.value)
    } catch (error) {
      console.error('Error registering push token:', error)
    }
  })

  PushNotifications.addListener('registrationError', (error) => {
    console.error('Push registration error:', error)
  })

  PushNotifications.addListener('pushNotificationReceived', (notification: PushNotificationSchema) => {
    console.log('Push notification received:', notification)
  })

  PushNotifications.addListener('pushNotificationActionPerformed', (action: ActionPerformed) => {
    console.log('Push notification action performed:', action)
  })
}

/**
 * Désenregistre l'appareil courant (à appeler à la déconnexion, par exemple).
 */
export const unregisterPushNotifications = async () => {
  const token = localStorage.getItem(registeredTokenKey)
  if (!token) {
    return
  }

  try {
    await budgetApi.unregisterPushToken(token)
  } catch (error) {
    console.error('Error unregistering push token:', error)
  } finally {
    localStorage.removeItem(registeredTokenKey)
  }
}
